
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetobangloreinnovacrystacab() {



    const cardData =
    {
        keyword: 'Pune to Bangalore Innova Crysta Cab',
        heading: 'Meghana Cab : Pune to Bangalore Innova Crysta Cab',
        headingDescription: 'Meghana Cab offers Pune to Bangalore Innova Crysta Cab Services Booking, tailored for business travelers, families, and groups seeking a smooth and premium intercity experience. Our top-of-the-line Innova Crysta cabs feature luxurious seating, roomy interiors, generous luggage space, and modern safety enhancements—making the long journey to Bangalore comfortable and secure.',


        top: 'Top Places to Visit in Bangalore with Meghana Cab',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Spanning ~240 acres, this historic 18th‑century botanical garden features over 1,000 plant species, a glasshouse modeled after London’s Crystal Palace, ancient rock formations, and bi‑annual flower shows – a green haven in the heart of the city." 
  },
  {
    "title": "Cubbon Park",
    "description": "A lush 300‑acre urban oasis in central Bengaluru, established in 1884. It’s dotted with colonial-era structures (library, aquarium, art gallery), tree-lined promenades, children’s train, and host to many local events." 
  },
  {
    "title": "Bangalore Palace",
    "description": "Built in 1887 by the Wodeyar family, this Tudor‑Gothic palace—with crenellated towers, wood carvings, stained‑glass windows and sprawling gardens—echoes Windsor Castle and offers a peek into royal lifestyles." 
  },
  {
    "title": "Tipu Sultan’s Summer Palace",
    "description": "An elegant 1791 Indo‑Islamic wooden palace in the old fort area. Known for its ornate arches, frescoes and historical artifacts, it served as Tipu Sultan’s summer retreat." 
  },
  {
    "title": "Bangalore Fort",
    "description": "Originally a 16th‑century mud fort by Kempe Gowda, rebuilt in granite by Hyder Ali and Tipu Sultan. Though much is ruined, the Delhi Gate and bastions remain, narrating tales of Mysore and colonial eras." 
  },
  {
    "title": "Nandi Hills",
    "description": "About 60 km from the city, this scenic hill station offers panoramic sunrise views, ancient temples, Tipu’s fort, cycling and trekking trails—ideal for a refreshing weekend escape." 
  },
  {
    "title": "Bannerghatta National Park",
    "description": "A wildlife sanctuary ~22 km from Bangalore featuring a zoo, butterfly park, snake park, aquarium and safari tours where you can spot tigers, lions and bears in natural settings." 
  },
  {
    "title": "Bull Temple (Dodda Basavana Gudi)",
    "description": "Built in 1537 in Dravidian style, this temple houses a massive 15‑ft black granite Nandi (bull) statue. A famous spiritual and cultural landmark in Basavanagudi." 
  },
  {
    "title": "Ulsoor Lake",
    "description": "A serene lake in the heart of Bengaluru with boating facilities and small islands. A popular spot for evening strolls and scenic relaxation." 
  },
  {
    "title": "Vidhana Soudha",
    "description": "An imposing white granite building housing Karnataka’s legislature. Built in Indo‑Saracenic style, it’s known as the ‘Taj Mahal of South India’ and is beautifully illuminated at night." 
  }
],

"services": [
  {
    "name": "Pune to Bangalore Innova Crysta Cab Booking",
    "description": "Book your Pune to Bangalore Innova Crysta cab for a scenic, smooth, and luxurious road trip. Our cabs are perfect for travelers who want a comfortable long-distance ride with professional chauffeurs, flexible stops, and ample space for passengers and luggage."
  },
  {
    "name": "One Way Innova Crysta Pune to Bangalore",
    "description": "Enjoy a stress-free one-way journey from Pune to Bangalore in a premium Innova Crysta. This service is ideal for solo travelers, families, or groups heading to Bangalore for business or leisure, providing door-to-door pickup and drop in a spacious, air-conditioned SUV."
  },
  {
    "name": "Round Trip Innova Crysta Pune Bangalore",
    "description": "Plan your Pune-Bangalore-Pune round trip with our reliable Innova Crysta cab service. Get complete travel flexibility, experienced drivers, and a comfortable ride ideal for both leisure and business travel, whether it's a weekend escape or a longer city visit."
  },
  {
    "name": "AC Innova Crysta Taxi Pune Bangalore",
    "description": "Beat the city heat with our fully air-conditioned Innova Crysta taxi from Pune to Bangalore. With plush seats, powerful AC, and smooth suspension, you’re guaranteed a relaxed and pleasant experience over the long highway drive."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune to Bangalore",
    "description": "Travel in style and ease with our chauffeur-driven Innova Crysta from Pune to Bangalore. Our trained drivers ensure safety, punctuality, and comfort, allowing you to sit back, relax, or enjoy the journey without any hassle."
  },
  {
    "name": "Private Innova Crysta Taxi Pune to Bangalore",
    "description": "Get the exclusivity and privacy you need with a private Innova Crysta taxi from Pune to Bangalore. Perfect for families, couples, or VIPs, this service provides a dedicated vehicle with no shared passengers, offering comfort and peace of mind."
  },
  {
    "name": "Online Booking Innova Crysta Cab Pune Bangalore",
    "description": "Book your Pune to Bangalore Innova Crysta cab online in just a few clicks. Our digital platform offers real-time availability, instant booking confirmations, secure payments, and the flexibility to choose your pickup time and location."
  },
  {
    "name": "Family Innova Crysta Trip Pune Bangalore",
    "description": "Make your Pune to Bangalore family trip extra comfortable with our spacious 6- or 7-seater Innova Crysta. With plenty of legroom, luggage space, and AC comfort, it’s perfect for vacations or family visits with kids, seniors, and large travel bags."
  },
  {
    "name": "Budget Innova Crysta Cab Pune Bangalore",
    "description": "Looking for a pocket-friendly yet premium ride to Bangalore? Our budget Innova Crysta cab service from Pune offers the perfect balance of comfort and affordability, ideal for group trips, weekend getaways, and long drives without compromising on quality."
  }
],
"tableData": [
  ["Pune to Bangalore Innova Crysta Cab Booking", "One Way Innova Crysta Pune Bangalore"],
  ["Round Trip Innova Crysta Pune Bangalore", "AC Innova Crysta Taxi Pune Bangalore"],
  ["Chauffeur Driven Innova Crysta Pune Bangalore", "Private Innova Crysta Taxi Pune Bangalore"],
  ["Online Booking Innova Crysta Pune Bangalore", "Family Innova Crysta Trip Pune Bangalore"],
  ["Budget Innova Crysta Cab Pune Bangalore", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Premium Pune to Goa Innova Crysta Cab Services",
        "WhyChoosedescription": "Enjoy a scenic and comfortable journey from Pune to Goa in a spacious, air-conditioned Innova Crysta. Perfect for family vacations, group travel, or beach getaways, our cab service offers luxury, safety, and reliability over the 450+ km route."
    },
    {
        "WhyChooseheading": "Spacious and Luxurious Interiors for Long Travel",
        "WhyChoosedescription": "The Innova Crysta is ideal for long-distance travel with its ample legroom, comfortable reclining seats, and superior suspension. Accommodating up to 6–7 passengers with plenty of luggage space, it ensures a relaxing journey even on hilly or coastal roads."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route and Terrain Expertise",
        "WhyChoosedescription": "Our trained drivers are well-versed with Pune–Goa routes, including scenic highways and safe hill paths. Whether you choose the NH66 coastal drive or the NH48 expressway, our drivers ensure a smooth, safe, and timely ride."
    },
    {
        "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
        "WhyChoosedescription": "All our Innova Crysta cabs are regularly cleaned, disinfected, and mechanically inspected before every trip. Travel worry-free in a hygienic and well-maintained vehicle that’s ready for a long journey."
    },
    {
        "WhyChooseheading": "Flexible Booking and Itinerary Customization",
        "WhyChoosedescription": "Choose one-way or round-trip bookings, single-day or multi-day packages, and customize your pickup/drop-off points and sightseeing stops en route. We tailor the travel plan to your convenience."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Our Pune to Goa cab fares are fully transparent with no hidden fees. The fare includes fuel, tolls, driver allowance, and taxes—delivering top-tier service at fair and honest rates."
    },
    {
        "WhyChooseheading": "Perfect for Beach Vacations, Events, and Group Tours",
        "WhyChoosedescription": "Whether you’re heading to Goa for a wedding, retreat, or fun with friends, the Innova Crysta ensures you travel in comfort and arrive refreshed. Ideal for groups and families seeking a luxurious travel experience."
    },
    {
        "WhyChooseheading": "24/7 Booking and Support Service",
        "WhyChoosedescription": "Book your cab online or through our customer support at any time, day or night. We offer real-time booking assistance, travel updates, and help with last-minute itinerary changes for a seamless trip."
    }
]























    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Bangalore?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or visit our website for a quick and convenient online booking."
    },
    {
        question: "What is the distance and travel time from Pune to Bangalore?",
        answer: "The distance is around 840 km, and the travel time typically ranges between 14 to 16 hours depending on the route and traffic."
    },
    {
        question: "Is Innova Crysta a good option for the Pune to Bangalore route?",
        answer: "Yes, Innova Crysta is perfect for long journeys like Pune to Bangalore, offering comfort, space, and smooth handling."
    },
    {
        question: "Can I book a one-way or round trip to Bangalore?",
        answer: "Yes, Meghana Cab offers both one-way and round-trip options for Pune to Bangalore travel."
    },
    {
        question: "What is included in the cab fare?",
        answer: "The fare includes driver charges, fuel, and tolls. Additional charges may apply for waiting time or parking if required."
    },
    {
        question: "Is the Innova Crysta available for family or group travel to Bangalore?",
        answer: "Absolutely. The Innova Crysta seats 6 to 7 passengers and is ideal for family vacations or group getaways."
    },
    {
        question: "Are the cabs sanitized before the trip?",
        answer: "Yes, all vehicles are thoroughly cleaned and sanitized before every journey to ensure your safety."
    },
    {
        question: "Do your drivers have experience with long-distance travel to Bangalore?",
        answer: "Yes, our drivers are highly experienced and familiar with Pune–Bangalore routes to ensure a safe and pleasant journey."
    },
    {
        question: "Is the Pune to Bangalore cab service available 24/7?",
        answer: "Yes, we operate round-the-clock so you can schedule your journey at any time convenient to you."
    },
    {
        question: "What payment modes are accepted for the booking?",
        answer: "We accept UPI, credit/debit cards, online banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Swapnil Kamat',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta from Pune to Bangalore. Clean car, smooth journey, and the driver was very polite and professional.”',
    },
    {
        name: 'Ms. Neha Sawant',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service! The Innova Crysta was perfect for our Bangalore trip. Spacious and extremely comfortable for long travel.”',
    },
];














































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const puneToBangaloreInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Bangalore Innova Crysta Cab",
  "description": "Book chauffeur-driven Innova Crysta cab services from Pune to Bangalore for one-way and round trips. Comfortable AC taxi ideal for family travel, business, and private trips at affordable rates.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Bangalore"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-bangalore-innova-crysta-cab"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune to Bangalore Innova Crysta Cab | AC Outstation Taxi Booking</title>
  <meta
    name="description"
    content="Hire Innova Crysta cab from Pune to Bangalore with chauffeur for comfortable AC rides. One-way and round-trip bookings available for family and business travel."
  />
  <meta
    name="keywords"
    content="Pune to Bangalore Innova Crysta Cab Booking, One Way Innova Crysta Pune Bangalore, Round Trip Innova Crysta Pune Bangalore, AC Innova Crysta Taxi Pune Bangalore, Chauffeur Driven Innova Crysta Pune Bangalore, Private Innova Crysta Taxi Pune Bangalore, Online Booking Innova Crysta Pune Bangalore, Family Innova Crysta Trip Pune Bangalore, Budget Innova Crysta Cab Pune Bangalore"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToBangaloreInnovaSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/43.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetobangloreinnovacrystacab;